import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logo from '../../Assets/logo.png';
import './Navbar.css';

const sections = ['home', 'about', 'services', 'network'];

const Navbar = () => {
  const [activeSection, setActiveSection] = useState('home');
  const [menuOpen, setMenuOpen] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const handleNavClick = (id) => {
    setMenuOpen(false);

    if (location.pathname !== '/') {
      navigate('/', { state: { targetId: id } });
    } else {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  /* ACTIVE STATE MANAGEMENT */
  useEffect(() => {
    const path = location.pathname;

    // 1. Dedicated Pages: Set active based on route
    if (path === '/about') {
      setActiveSection('about');
    } else if (path.startsWith('/services')) {
      setActiveSection('services');
    } else if (path === '/contact') {
      setActiveSection('contact');
    } else if (path === '/business') {
      setActiveSection('business');
    } else if (path === '/') {
      // 2. Home Page: Use Scroll Spy
      const onScroll = () => {
        let current = 'home';
        // Only check home sections if we're on home
        sections.forEach((id) => {
          const sec = document.getElementById(id);
          if (sec && window.scrollY >= sec.offsetTop - 140) {
            current = id;
          }
        });
        setActiveSection(current);
      };

      // Run immediately to set initial state on load/nav
      onScroll();

      window.addEventListener('scroll', onScroll);
      return () => window.removeEventListener('scroll', onScroll);
    } else {
      setActiveSection(''); // Default - no active section
    }
  }, [location.pathname]);

  return (
    <nav className={`custom-navbar ${menuOpen ? 'menu-open' : ''}`}>
      <div className="nav-container">

        {/* LOGO */}
        <Link to="/" className="nav-logo" onClick={() => handleNavClick('home')}>
          <img src={logo} alt="Janta Roadways" />
        </Link>

        {/* HAMBURGER */}
        <button
          className={`hamburger ${menuOpen ? 'active' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* NAV LINKS */}
        <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
          <li className={activeSection === 'home' ? 'active' : ''}>
            <button onClick={() => handleNavClick('home')}>HOME</button>
          </li>

          <li className={activeSection === 'about' ? 'active' : ''}>
            <Link to="/about" onClick={() => setMenuOpen(false)}>ABOUT US</Link>
          </li>

          <li className={activeSection === 'services' ? 'active' : ''}>
            <Link to="/services" onClick={() => setMenuOpen(false)}>SERVICES</Link>
          </li>



          <li className={activeSection === 'business' ? 'active' : ''}>
            <Link
              to="/business"
              onClick={() => {
                setMenuOpen(false);
                window.scrollTo({ top: 0, behavior: 'instant' }); // Forces top immediately
              }}
            >
              BUSINESSES
            </Link>
          </li>

          <li className={activeSection === 'contact' ? 'active' : ''}>
            <Link to="/contact" onClick={() => setMenuOpen(false)}>CONTACT US</Link>
          </li>

        </ul>
        <div className="nav-cta">
          <Link to="/contact">Contact us</Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
